import { AnnouncementBar } from '@/components/AnnouncementBar';
import { ExcursionCard } from '@/components/ExcursionCard';
import { HeaderSubPage } from '@/components/HeaderSubPage';
import { Navbar } from '@/components/Navbar';
import { useItineraryContext } from '@/context/ItineraryContext';
import { EnforcePageWidth } from '@/layout/PageLayout';

import { isExcursion } from './helpers';
import { StyledExcursionCardWrapper } from './styles';

export function ExcursionsPage() {
  const { data } = useItineraryContext();

  return (
    <>
      <AnnouncementBar />
      <Navbar variant="secondary" />
      <HeaderSubPage title="Your activities" emptyHeader />
      {data?.ItineraryBlocks.map((block) => (
        <EnforcePageWidth key={block.id}>
          <h2>{block.location}</h2>

          {block.ItineraryProducts.map(
            (product) =>
              isExcursion(product) && (
                <StyledExcursionCardWrapper key={product.id}>
                  <ExcursionCard itineraryProduct={product} />
                </StyledExcursionCardWrapper>
              ),
          )}
        </EnforcePageWidth>
      ))}
    </>
  );
}
